<template>
    <div style="position: relative"
        >
        <div class="verify-img-out">
            <div class="verify-img-panel" :style="{'width': setSize.imgWidth,
                                                   'height': setSize.imgHeight,
                                                   'background-size' : setSize.imgWidth + ' '+ setSize.imgHeight,
                                                   'margin-bottom': vSpace + 'px'}"
                                                    >
                <div class="verify-refresh" style="z-index:3" @click="refresh" v-show="showRefresh">
                    <i class="iconfont icon-refresh"></i>
                </div>
                <img :src="'data:image/png;base64,'+pointBackImgBase"
                ref="canvas"
                alt=""  style="width:100%;height:100%;display:block"
                @click="bindingClick?canvasClick($event):undefined">

                <div v-for="(tempPoint, index) in tempPoints" :key="index" class="point-area"
                     :style="{
                        'background-color':'#1abd6c',
                        color:'#fff',
                        'z-index':9999,
                        width:'20px',
                        height:'20px',
                        'text-align':'center',
                        'line-height':'20px',
                        'border-radius': '50%',
                        position:'absolute',
                        top:parseInt(tempPoint.y-10) + 'px',
                        left:parseInt(tempPoint.x-10) + 'px'
                     }">
                    {{index + 1}}
                </div>
            </div>
        </div>
        <!-- 'height': this.barSize.height, -->
        <div class="verify-bar-area"
             :style="{'width': setSize.imgWidth,
                      'color': this.barAreaColor,
                      'border-color': this.barAreaBorderColor,
                      'line-height':this.barSize.height}">
            <span class="verify-msg">{{text}}</span>
        </div>
    </div>
</template>
<script type="text/babel">
    /**
     * VerifyPoints
     * @description 点选
     * */
    import {resetSize} from './../utils/util'
    import {aesEncrypt} from "./../utils/ase"
    import {reqGet,reqCheck}  from "./../api/index"

    export default {
        name: 'VerifyPoints',
        props: {
            mode: {
                type: String,
                default: 'fixed'
            },
            captchaType:{
                type:String,
            },
            vSpace: {
                type: Number,
                default: 5
            },
            imgSize: {
                type: Object,
                default() {
                    return {
                        width: '310px',
                        height: '155px'
                    }
                }
            },
            barSize: {
                type: Object,
                default() {
                    return {
                        width: '310px',
                        height: '40px'
                    }
                }
            }
        },
        data() {
            return {
                secretKey: '',
                checkNum: 3,
                fontPos: [],
                checkPosArr: [],
                num: 1,
                pointBackImgBase: '',
                poinTextList: [],
                backToken: '',
                setSize: {
                    imgHeight: 0,
                    imgWidth: 0,
                    barHeight: 0,
                    barWidth: 0
                },
                tempPoints: [],
                text: '',
                barAreaColor: undefined,
                barAreaBorderColor: undefined,
                showRefresh: true,
                bindingClick: true
            }
        },
        mounted() {
            this.init()
            this.$el.onselectstart = function () {
                return false
            }
        },
        methods: {
            init() {
                var self = this
                this.fontPos.splice(0, this.fontPos.length)
                this.checkPosArr.splice(0, this.checkPosArr.length)
                this.num = 1
                this.getPictrue()
                this.$nextTick(function() {
                    var sizeObj = resetSize(self)
                    self.setSize.imgHeight = sizeObj.imgHeight
                    self.setSize.imgWidth = sizeObj.imgWidth
                    self.setSize.barHeight = sizeObj.barHeight
                    self.setSize.barWidth = sizeObj.barWidth
                    self.$parent.$emit('ready', self)
                })
            },
            canvasClick(e) {
                var self = this
                this.checkPosArr.push(this.getMousePos(this.$refs.canvas, e))
                if (this.num == this.checkNum) {
                    this.num = this.createPoint(this.getMousePos(this.$refs.canvas, e))
                    var arr = this.pointTransfrom(this.checkPosArr, this.setSize)
                    this.checkPosArr.length = 0
                    this.checkPosArr.push.apply(this.checkPosArr, arr)
                    setTimeout(function() {
                        var captchaVerification = self.secretKey ? aesEncrypt(self.backToken + '---' + JSON.stringify(self.checkPosArr), self.secretKey) : self.backToken + '---' + JSON.stringify(self.checkPosArr)
                        var data = {
                            captchaType: self.captchaType,
                            "pointJson": self.secretKey ? aesEncrypt(JSON.stringify(self.checkPosArr), self.secretKey) : JSON.stringify(self.checkPosArr),
                            "token": self.backToken
                        }
                        reqCheck(data).then(function(res) {
                            if (res.repCode == "0000") {
                                self.barAreaColor = '#4cae4c'
                                self.barAreaBorderColor = '#5cb85c'
                                self.text = '验证成功'
                                self.bindingClick = false
                                if (self.mode == 'pop') {
                                    setTimeout(function() {
                                        self.$parent.clickShow = false
                                        self.refresh()
                                    }, 1500)
                                }
                                self.$parent.$emit('success', {captchaVerification: captchaVerification})
                            } else {
                                self.$parent.$emit('error', self)
                                self.barAreaColor = '#d9534f'
                                self.barAreaBorderColor = '#d9534f'
                                self.text = '验证失败'
                                setTimeout(function() {
                                    self.refresh()
                                }, 700)
                            }
                        })
                    }, 400)
                }
                if (this.num < this.checkNum) {
                    this.num = this.createPoint(this.getMousePos(this.$refs.canvas, e))
                }
            },
            getMousePos(obj, e) {
                var x = e.offsetX
                var y = e.offsetY
                return {x: x, y: y}
            },
            createPoint(pos) {
                this.tempPoints.push(Object.assign({}, pos))
                return this.num + 1
            },
            refresh() {
                this.tempPoints.splice(0, this.tempPoints.length)
                this.barAreaColor = '#000'
                this.barAreaBorderColor = '#ddd'
                this.bindingClick = true
                this.fontPos.splice(0, this.fontPos.length)
                this.checkPosArr.splice(0, this.checkPosArr.length)
                this.num = 1
                this.getPictrue()
                this.text = '验证失败'
                this.showRefresh = true
            },
            getPictrue() {
                var self = this
                var data = {
                    captchaType: this.captchaType
                }
                reqGet(data).then(function(res) {
                    if (res.repCode == "0000") {
                        self.pointBackImgBase = res.repData.originalImageBase64
                        self.backToken = res.repData.token
                        self.secretKey = res.repData.secretKey
                        self.poinTextList = res.repData.wordList
                        self.text = '请依次点击【' + self.poinTextList.join(",") + '】'
                    } else {
                        self.text = res.repMsg
                    }
                })
            },
            pointTransfrom(pointArr, imgSize) {
                var newPointArr = pointArr.map(function(p) {
                    var x = Math.round(310 * p.x / parseInt(imgSize.imgWidth))
                    var y = Math.round(155 * p.y / parseInt(imgSize.imgHeight))
                    return {x: x, y: y}
                })
                return newPointArr
            }
        }
    }
</script>
